module.exports = __webpack_public_path__ + "img/alta_performance_e_ajuda.b869eb94.svg";